import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export function SchoolDisclaimer() {

    var [alllowProceed, setalllowProceed] = useState(false);
    var toggleProceedtoForm = () => setalllowProceed(!alllowProceed);

    const triggerForm = () => {
        sessionStorage.setItem('sdc', 1);
        //window.wogaaCustom && window.wogaaCustom.startTransactionalService('ArchivesOnline-2859');
        if (sessionStorage.getItem('sfs')) {
            sessionStorage.removeItem('sfs');
        }

        setTimeout(() => {
            window.location.href = "./school/form"
        }, 500);
    }

    return (
        <section id="SchoolDisclaimer">
            <div className="container-fluid mt-3 disclaimer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <img src="./images/icn-OnTopSchool.png" alt="" />
                                <h2 className="pageTitle mt-2">School Record</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-8 offset-md-2">
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex justify-content-center">
                                    <div className="card-content">
                                        <div className="text-center mb-3">
                                            <h3 className="theme-color">Getting Started</h3>
                                        </div>
                                        <div>
                                            <div>
                                                <label className="theme-color">
                                                    <input type="checkbox" value={alllowProceed} onChange={toggleProceedtoForm} />
                                                    <span className="ps-2">I agree for NAS to conduct the search based on the terms below:</span>
                                                </label>
                                            </div>
                                            <ul className="theme-color">
                                                <li>For school records from 1982 onwards, please contact the Ministry of Education. More details <a className="fw-bold" href="https://form.gov.sg/5d0b535fe6ca2a00111f3868">here</a>. </li>
                                                <li>NAS can only verify school records based on records that were transferred to NAS. </li>
                                                <li>Should the school’s records be transferred to NAS to carry out the search, a non-refundable Request Administration Fee of ${parseFloat(process.env.REACT_APP_ADMINFEE)} (inclusive of {parseInt(process.env.REACT_APP_GST)}% GST) will be levied. After the search, NAS will provide a letter stating the outcome. </li>
                                                <li>
                                                    The outcome of the search will only be provided to the pupil of the school. You will be asked to verify your identity or prove you are an authorized proxy for the pupil before we can conduct the search.
                                                </li>
                                                <li>We will update you on the outcome of the search within 3 working days of verifying your identity.</li>
                                            </ul>
                                        </div>
                                        <div className="theme-color text-center">To learn more, click <Link className="fw-bold" to="/school/guide">here</Link>.</div>
                                        <div className="text-center mt-3">
                                            {!alllowProceed && <button type="button" disabled={true} className="btn btn-primary me-2">Proceed</button>}
                                            {alllowProceed && <button type="button" onClick={triggerForm} className="btn btn-primary me-2">Proceed</button>}
                                            <Link to={'/'} className="btn btn-secondary">Cancel</Link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





